import moment from 'moment'

export const defaulFilter = {
	month: moment(new Date()).format('MM'),
	year: moment(new Date()).format('YYYY'),
}
